import { render, staticRenderFns } from "./ReportBrigadePerformedTasks.vue?vue&type=template&id=057d8c44&"
import script from "./ReportBrigadePerformedTasks.vue?vue&type=script&lang=js&"
export * from "./ReportBrigadePerformedTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QBtn,QTr,QTh,QTd,QTooltip,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QBtn,QTr,QTh,QTd,QTooltip,QInnerLoading,QSpinnerGears}, component.options.components || {})
